import { Box, Card, CardContent, Typography } from "@mui/material";

type CardLogType = {
  title: string;
  data: any;
};
export const CardLog = ({ data, title }: CardLogType) => {
  return (
    <Card sx={{ display: "flex", flex: 1, boxShadow: 3 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          pb: "16px !important",
        }}
      >
        <Box>
          <Typography variant="subtitle1">{title}</Typography>
        </Box>
        <pre
          style={{
            width: "100%",
            maxHeight: "100%",
            overflow: "auto",
            margin: 0,
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
};
